import React from 'react';
import Image from '../../Atoms/Image/Image';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import './SocialMediaFooter.scss';
import Link from '../../Atoms/Link/Link';
import { FooterComponentsProps, NavigationSectionItem } from '../../Interfaces/FooterInterface';

const SocialMediaFooter: React.FC<FooterComponentsProps> = ({ apiData, analyticsHandler, testAutoId }) => {
  const navigationSections = _get(apiData, ['navigationSections'], []);
  const navigationColumn =
    !_isEmpty(navigationSections) &&
    _get(navigationSections, ['0', 'navigationSectionItems'], []).map(
      (link: NavigationSectionItem) => {
        const title = _get(link, ['title'],'');
        const imageComponent = (
          <Image alt={_get(link, ['imageAlt'], '')} key={title} imageSources={_get(link, ['imageSrc'])} />
        );
        return (
          <Link onClick={() => analyticsHandler(title, false)} href={_get(link, ['href'])} key={title} text={imageComponent} />
        );
      },
    );

  return <div className="social-footer__container" data-testid={testAutoId}>{navigationColumn}</div>;
};

export default SocialMediaFooter;
